export const useMenuStore = defineStore('menu', () => {
    const topMain = ref([]);
    const footerMain = ref([]);
    const footerBottom = ref([]);
    const profile = ref([]);
    const vipProducts = ref([]);
    const topSellerProducts = ref([]);
    const blogItems = ref([]);

    function initData(data) {
        topMain.value = data.top_main;
        footerMain.value = data.footer_main;
        footerBottom.value = data.footer_bottom;
        profile.value = data.profile;
        vipProducts.value = data.vip_products || [];
        blogItems.value = data.blog_items || [];
    }

    async function initMenu() {
        const data = await getFromClient('init/menu');
        initData(data);
    }

    return {
        topMain,
        footerMain,
        footerBottom,
        profile,
        initData,
        initMenu,
        vipProducts,
        topSellerProducts,
        blogItems,
    };
});
